var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M24 13.867C24 15.045 22.977 16 21.714 16H2.286C1.023 16 0 15.045 0 13.867V2.133C0 .955 1.023 0 2.286 0h19.428C22.977 0 24 .955 24 2.133v11.734z",
    transform: "translate(-820 -1481) translate(81 1463) translate(739 18) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6.963 5.333l-1.5 4.177s-.381-1.767-.419-1.988c-.854-1.82-2.115-1.718-2.115-1.718L4.415 11.2v-.001H6.22L8.72 5.333H6.963zm1.43 5.867h1.641l.992-5.867h-1.66L8.393 11.2zm11.612-5.867h-1.727L15.587 11.2h1.63l.336-.838h2.054l.175.838h1.493l-1.27-5.867zm-1.998 3.909l.894-2.217.467 2.217h-1.36zm-4.653-2.199c0-.323.284-.564 1.1-.564.53 0 1.138.36 1.138.36l.266-1.232s-.776-.274-1.537-.274c-1.726 0-2.615.77-2.615 1.745 0 1.763 2.273 1.521 2.273 2.427 0 .155-.132.514-1.078.514-.95 0-1.577-.325-1.577-.325l-.283 1.182s.608.323 1.781.323c1.177 0 2.809-.82 2.809-2 0-1.42-2.277-1.522-2.277-2.156z",
    transform: "translate(-820 -1481) translate(81 1463) translate(739 18) translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M5.264 8.504l-.552-2.532s-.25-.55-.899-.55H1.276s3.235.893 3.988 3.082z",
    transform: "translate(-820 -1481) translate(81 1463) translate(739 18) translate(0 4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e5f49cb362a15489265d322539096a5a.svg";
export { ForwardRef as ReactComponent };